import * as React from 'react';

import { Button, Card, Flex, Tag, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { dateFormat } from 'v2/formatters/date';

type EnvironmentVariant = 'front' | 'api' | 'vertical';

type EnvironmentProps = {
  name: string;
  env: string;
  branch: string;
  date: string;
  redirect: string;
  variant?: EnvironmentVariant;
  hidden?: boolean;
};

type DetailLineProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
};

const VARIANT_THEME = {
  front: { color: 'blue', label: 'Front' },
  api: { color: 'green', label: 'API' },
  vertical: { color: 'purple', label: 'Vertical' }
} as const;

function getValue(value: string, hidden?: boolean) {
  if (hidden || !value) {
    return '-';
  }

  return value;
}

function getDateValue(date: string, hidden?: boolean) {
  if (hidden || !date) {
    return '-';
  }

  return dateFormat(date, 'dd/MM/yyyy HH:mm:ss');
}

function DetailLine({ icon, label, value }: DetailLineProps) {
  return (
    <Flex align='center' gap='small'>
      <Typography.Text type='secondary'>{icon}</Typography.Text>
      <Typography.Text strong>{label}:</Typography.Text>
      <Typography.Text ellipsis>{value}</Typography.Text>
    </Flex>
  );
}

function Details({ name, env, branch, date, redirect, variant = 'front', hidden = false }: EnvironmentProps) {
  const theme = VARIANT_THEME[variant];

  return (
    <Card
      className='min-w-75'
      size='small'
      title={
        <Flex align='center' gap='small'>
          <Typography.Text strong ellipsis>
            {name}
          </Typography.Text>
          <Tag color={theme.color}>{theme.label}</Tag>
        </Flex>
      }
      extra={
        <a href={redirect} target='_blank' rel='noreferrer' aria-label={`Abrir ${name}`}>
          <Tooltip title='Abrir no GitHub'>
            <Button shape='circle' type='text' icon={<Icon.ArrowRight  />} />
          </Tooltip>
        </a>
      }
    >
      <Flex vertical gap='small'>
        <DetailLine icon={<Icon.Box  />} label='Env' value={getValue(env, hidden)} />
        <DetailLine icon={<Icon.GitBranch  />} label='Branch' value={getValue(branch, hidden)} />
        <DetailLine icon={<Icon.Calendar  />} label='Data de Atualização' value={getDateValue(date, hidden)} />
      </Flex>
    </Card>
  );
}

export { Details };
